<template>
  <div>
    <div class="searchBox" ref="searchBox" >
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px"
        size="mini">
        <div class="searchBox inpBox" >
          <div class="item">
            <el-form-item label="司机姓名:" label-width="75px">
              <el-input placeholder="" maxlength="20" v-model.trim="searchFrom.name"></el-input>
            </el-form-item>
            <el-form-item label="创建时间:">
              <el-date-picker
                v-model="searchFrom.createTimes"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker>
            </el-form-item>
          </div>
        </div>
        <div class="searchBtnBox" style="margin-top: 10px; margin-bottom: 10px;">
          <el-form-item>
            <el-button type="primary" @click="searchFn" size="mini">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')" size="mini">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addFn" size="mini">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="daoru" size="mini">导入</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="daochu" :disabled='isDisable' size="mini">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="editFn" size="mini">修改</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delFn" size="mini">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="xiazai" size="mini">下载模板</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change='selectGoods'
        class="table" height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column property="name" :formatter="emptyFn" label="司机姓名"></el-table-column>
        <el-table-column property="" :formatter="emptyFn" label="司机所属">
          <template scope="scope">
            <span v-show="scope.row.driverClassify == '1'">自有</span>
            <span v-show="scope.row.driverClassify == '2'">外协</span>
          </template>
        </el-table-column>
        <el-table-column property="mobile" :formatter="emptyFn" label="司机电话"></el-table-column>
        <el-table-column property="identityNo" :formatter="emptyFn" label="身份证号"></el-table-column>
        <el-table-column property="createUser" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[25, 50, 100]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="isAdd ? '新建' : '修改'" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"
      @close="closeDialog" :visible.sync="dialogVisible" width="70%" center>
      <div >
        <el-table :data="addList" ref="tableAdd" bordersize="mini" style="width: 100%" height="500" center border :header-cell-class-name="starSetting">
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="操作" width="100" v-if="isAdd">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="delAddFN(scope.$index)">删除</el-button>
                <el-button type="text" size="mini" @click="fuzhiFN(scope.row)">复制</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="司机姓名" min-width="120" prop="name">
            <template slot-scope="scope">
              <div class="box1">
                <el-input maxlength="20" v-model.trim="scope.row.name"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="司机电话" min-width="130" prop="mobile">
            <template slot-scope="scope">
              <div class="box1">
                <el-input maxlength="11" v-model.trim="scope.row.mobile" v-number-input.float="0" @blur="mobile(scope.row.mobile)"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="司机身份证号" min-width="180">
            <template slot-scope="scope">
              <div class="box1">
                <el-input maxlength="18" v-model.trim="scope.row.identityNo" v-number-input.float="0" @blur="identityNoInput(scope.row.identityNo)"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="司机归属" min-width="120" prop="driverClassify">
            <template slot-scope="scope">
              <div class="box1">
                <el-select v-model="scope.row.driverClassify" placeholder="请选择">
                  <el-option v-for="item in CSList" :key="item.showName" :label="item.showName" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addList')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <daoru v-if="daoruMark" :daoruMark.sync="daoruMark"></daoru>
  </div>
</template>

<script>
// import axios from 'axios'
import { getBtn } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { findDriverInfoList,addDriverInfoList,updateDriverInfoList,deleteDriverInfo } from '@/api/newTMS'
import { emptyFn, dateFormat, dateTimeFormat,IdentityCodeValid } from '@/utils/util'
import daoru from './daoruDriver.vue'
const vhsrule = /^1[3456789]\d{9}$/
export default {
  components: { daoru },
  data () {
    return {
      emptyFn: emptyFn,
      dateFormat: dateFormat,
      dateTimeFormat: dateTimeFormat,
      dialogVisible: false,
      loading: false,
      daoruMark: false,
      h: '500px',
      total: 0,
      addList: [{}],
      CSList: [
        {
          value:1,
          showName: '自有'
        },
        {
          value:2,
          showName: '外协'
        }
      ],
      isAdd: true,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      addList: {},
      tableList: [],
      selectionList: [],
      btnFlg: [],
      btnIdArr: [
        '01L00C0100',
        '01L00C0200',
        '01L00C0300',
        '01L00C0400',
        '01L00C0500',
        '01L00C0600',
        '01L00C0700',
      ],
      isDisable:false,
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ]
      },
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/driverTMS')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 148) + 'px'
  },
  methods: {
    starSetting (obj) {
      if (obj.column.property == 'name' || obj.column.property == 'mobile' || obj.column.property == 'driverClassify') {
        return 'star'
      }
    },
    daoru () {
      this.daoruMark = true
    },
    // 复制
    fuzhiFN (row) {
      this.addList.push({ ...row })
    },
    // 新建删除
    delAddFN (index) {
      this.addList.splice(index, 1)
    },
    // 新建
    addFn () {
      this.dialogVisible = true
      this.isAdd = true
      this.addList = [{}]
      // this.$refs.addList.clearValidate()
    },
    mobile(val){
      if (!vhsrule.test(val)) {
        this.$message({ message: '请输入正确的手机号', type: 'error' })
      }
    },
    identityNoInput (val) {
      if(val){
        if (!IdentityCodeValid(val)) {
          this.$message({ message: '请输入正确的身份证号', type: 'error' })
        }
      }
    },
    // 修改
    editFn (row) {
      if (this.selectionList.length == 0) {
        this.$message({
          message: '请选择要操作的数据',
          type: 'error'
        })
        return
      }
      this.isAdd = false
      this.addList = JSON.parse(JSON.stringify(this.selectionList))
      this.dialogVisible = true
      this.addList.forEach((item, index) => {
        // item.driverDate = new Date(item.driverDate)
      })
    },
    saveFn (formName) {
      let flag = this.addList.every((item, index) => {
        let n = index + 1
        // 司机姓名，司机电话，司机所属必填
        if (!item.name) {
          this.$message({
            message: '请完善第' + n + '条司机姓名',
            type: 'error'
          })
          return false
        } else {
          return true
        }
      })
      if (!flag) {
        return
      }
      let mobile = this.addList.every((item, index) => {
        let n = index + 1
        if (!vhsrule.test(item.mobile)) {
          this.$message({
            message: '请正确填写第' + n + '条手机号',
            type: 'error'
          })
          return false
        } else {
          return true
        }
      })
      // console.log(mobile,'mobile')
      if (!mobile) {
        return
      }
      let driverClassify = this.addList.every((item, index) => {
        let n = index + 1
        if (!item.driverClassify) {
          this.$message({
            message: '请完善第' + n + '条司机所属',
            type: 'error'
          })
          return false
        } else {
          return true
        }
      })
      // console.log(identityNo,'identityNo')
      if (!driverClassify) {
        return
      }
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addDriverInfoList(this.addList)
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        updateDriverInfoList(this.addList)
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }
    },
    // 删除
    delFn () {
      if (this.selectionList.length == 0) {
        this.$message({
          message: '请选择要操作的数据',
          type: 'error'
        })
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let ids = []
          this.selectionList.forEach(item => {
            ids.push(item.id)
          })
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          deleteDriverInfo({ ids: ids })
            .then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        })
        .catch(() => { })
    },
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/tmsPlus/%E5%8F%B8%E6%9C%BA%E7%AE%A1%E7%90%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      )
    },
    // 查选
    searchFn () {
      console.log(this.searchFrom, 'this.searchFrom')
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.selectionList = this.$refs.table.selection
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      findDriverInfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog () {
      this.addList = []
      this.$refs.table.clearSelection()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList(this.searchFrom)
    },
    daochu(){
      exportExcel(
        this.global.tmsPlus + '/driverInfo/exportList',
        this.searchFrom,
        '司机列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang='less'>
.searchBox {
  display: flex;
}
.box1 {
  display: flex;
  padding: 6px;
}
.searchBox .el-date-editor {
  width: 350px !important;
}
.jiaoyan {
  /deep/.el-input__inner {
    height: 30px;
  }

  .el-input__icon {
    line-height: 30px;
  }
}
/deep/.el-cascader {
  width: 210px;
  flex-shrink: 0;
  line-height: 30px;
}
/deep/.el-table th.star div::before{
  content: '*' !important;
  color: red !important;
}
</style>
